<template>
  <div class="team-arrival-live-location-map">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="top-navbar-left">
              <div
                class="btn-back"
                @click="$router.push({ name: 'teamArrivalLiveLocation' })"
              >
                <font-awesome-icon :icon="['fas', 'angle-left']" />Back
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-center">TL LIVE LOCATION</div>
          </div>

          <div class="col-md-4">
            <!-- <div class="top-navbar-right">
                <button class="btn btn-ecdc">Export Report</button>
            </div> -->
          </div>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-lg-7">
          <div class="table-responsive">
            <table class="table table-striped table-hover result-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>TL Name</th>
                  <th>TEAM NAME</th>
                  <th>VENUE</th>
                  <th>DURATION</th>
                  <th>CHECK IN</th>
                  <th>TOTAL CDC</th>
                  <th>TEAM ROUTE</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(liveGps, index) in liveGpsData.result"
                  v-bind:key="liveGps.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ liveGps.tl_name }}</td>
                  <td>{{ liveGps.team_name }}</td>
                  <td>{{ liveGps.venue }}</td>
                  <td>{{ liveGps.duration }}</td>
                  <td>{{ liveGps.check_in }}</td>
                  <td>
                    {{ liveGps.total_cdc }}
                  </td>
                  <td
                    class="text-center"
                    @click="
                      $router.push({
                        name: 'teamArrivalTeamRoute',
                        params: { id: liveGps.id },
                      })
                    "
                  >
                    <button class="btn btn-link btn-icon icon-right">
                      View
                      <font-awesome-icon
                        class="icon"
                        :icon="['fas', 'angle-right']"
                      />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-lg-5">
          <div id="cdcMap"></div>
        </div>
      </div>
    </div>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import { getTeamLeaderLiveGPSsByArea } from "../api";
import Loader from "./Loader.vue";

export default {
  components: {
    appLoader: Loader,
  },
  data() {
    return {
      styledMapType: "",
      map: "",
      liveGpsData: [],
      isLoading: true,
    };
  },
  async mounted() {
    this.styledMapType = new window.google.maps.StyledMapType(
      JSON.parse(process.env.VUE_APP_MAP),
      { name: "Styled Map" }
    );
    await this.getTeamLeaderLiveGPSs();
    this.isLoading = false;
  },
  methods: {
    async getTeamLeaderLiveGPSs() {
      try {
        const result = await getTeamLeaderLiveGPSsByArea(
          this.$route.params.area_id
        );
        this.liveGpsData = result.data.data;
        this.initMap();
      } catch (err) {
        window.errorCode = err;
      }
    },
    initMap() {
      
      const _this = this;

      // get first map value if not use dummy ones
      let lat = "-6.1843548"
      let long = "106.7480016";

      if(this.liveGpsData.result.length > 0) {
        for (let i = 0; i < this.liveGpsData.result.length; i++) {
          if(_this.liveGpsData.result[i].lat != null && _this.liveGpsData.result[i].long != null) {

              lat = _this.liveGpsData.result[i].lat;
              long = _this.liveGpsData.result[i].long;
              break;
            }
        } 
      }

      this.map = new window.google.maps.Map(document.getElementById("cdcMap"), {
        center: {
          lat: parseFloat(lat),
          lng: parseFloat(long),
        },
        scrollwheel: false,
        zoom: 6,
      });
      this.map.mapTypes.set("styled_map", this.styledMapType);
      this.map.setMapTypeId("styled_map");

      if (this.liveGpsData.result.length > 0) this.pinLocation();
    },
    pinLocation() {
      this.liveGpsData.result.forEach(function (location, index) {
        if (isNaN(location.lat) || isNaN(location.long) || location.lat == null || location.long == null) return;
        const template = this.templateString(index);
        new window.google.maps.Marker({
          position: {
            lat: parseFloat(location.lat),
            lng: parseFloat(location.long),
          },
          animation: window.google.maps.Animation.DROP,
          map: this.map,
          icon: {
            url:
              "data:image/svg+xml;charset=UTF-8," +
              encodeURIComponent(template),
            scaledSize: new window.google.maps.Size(40, 40),
          },
          title: "LIVE",
        });
      }, this);
    },
    templateString(index) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="24.558" height="31.617" viewBox="0 0 24.558 31.617">\
        <g id="pin-yellow-sequence" transform="translate(-1318.569 -659.191)">\
        <g id="maps-and-flags" transform="translate(1261.418 659.191)">\
        <path id="Path_57" data-name="Path 57" d="M81.71,12.279c0,9.832-11.1,18.939-11.1,18.939a1.942,1.942,0,0,1-2.359,0s-11.1-9.106-11.1-18.939a12.279,12.279,0,0,1,24.559,0Z" fill="#fdcd08"/>\
        <path id="Path_58" data-name="Path 58" d="M165.417,117.721a9.458,9.458,0,1,1,9.458-9.458A9.468,9.468,0,0,1,165.417,117.721Z" transform="translate(-95.986 -95.984)" fill="#2b4162"/>\
        </g>\
        <text id="_1" data-name="1" transform="translate(1334 675.5)" fill="#fdcd08" font-size="12" font-family="Arial-BoldMT, Arial" font-weight="700" text-anchor="middle"><tspan x="-3.337" y="0">\
        ${index + 1}\
        </tspan></text>\
        </g>\
        </svg>`;
    },
  },
};
</script>

<style scoped>
#cdcMap {
  width: 100%;
  height: 550px;
}
</style>
